module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uprid-layout"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loader"
  }) : (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n    " + _vm._s(_vm.error.message || JSON.stringify(_vm.error, null, 2)) + "\n  ")]) : _c('div', [_c('QuestionnaireAutofill'), _vm._v(" "), _c('SmevRequestSync'), _vm._v(" "), _c('PersonalData'), _vm._v(" "), _c('Contracts'), _vm._v(" "), (false) ? _c('details', [_c('summary', [_vm._v("\n        Документы, подтверждающие квалификацию и репутацию клиентов\n      ")]), _vm._v(" "), _c('Documents', {
    attrs: {
      "documents": _vm.documents
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25257f23"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Uprid/Index.vue
// module id = 913
// module chunks = 0